// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1yQvN","description":"PatientConsentPreview_description__mSj5M"};